import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=136ec468&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=136ec468&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ec468",
  null
  
)

export default component.exports